import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Datalist } from '@ktag/styleguide/dist/react';
import { Eigentuemer, Eigentum } from '../api/useLandowners';

interface LandownerEigentuemerProps {
  eigentum: Eigentum;
  eigentuemer: Eigentuemer;
  isFirstItem: Boolean;
}

const LandownerEigentuemer = ({
  eigentum,
  eigentuemer,
  isFirstItem,
}: LandownerEigentuemerProps) => {
  const { t } = useTranslation('agisviewer');

  const displayProperty = () => {
    const { bezeichnung, anteilZaehler, anteilNenner, art, zusatz } = eigentum;

    let text = bezeichnung.endsWith('Miteigentum')
      ? `${bezeichnung} ${anteilZaehler}/${anteilNenner}`
      : bezeichnung;

    if (art) text += `, ${art}`;
    if (zusatz) text += ` ${zusatz}`;

    return text;
  };

  const displayOwnerName = () => {
    if (eigentuemer.art === 'natuerlich') {
      return `${eigentuemer.name} ${eigentuemer.vorname}`;
    }

    if (eigentuemer.art === 'juristisch') {
      const uidFirma = eigentuemer.uidFirma
        ?.replace(/(\d{3})/g, '.$1')
        ?.replace(/(\.)/, ' ');

      const uid = uidFirma ? ` (UID: ${uidFirma})` : '';
      return `${eigentuemer.nameFirma}, ${eigentuemer.sitzFirma}${uid}`;
    }

    return t('landowner_errorNoEgrid_message');
  };

  const items = eigentuemer.adresse.map((adresse: any) => {
    const [key, value] = adresse.displayAddress.split(':');
    return {
      key: `${key}:`,
      value,
    };
  });

  return (
    <div className={classNames('landowner__result', { first: isFirstItem })}>
      {isFirstItem && (
        <div className="landowner__result-title">
          <div className="numbered" />
          <div>{displayProperty()}</div>
        </div>
      )}
      <div className="landowner__result-details">
        <div className="landowner__result-owner-name">{displayOwnerName()}</div>
        <Datalist items={items} />
      </div>
    </div>
  );
};

export default LandownerEigentuemer;
